import { render, staticRenderFns } from "./ProductZoom.vue?vue&type=template&id=91344686&scoped=true"
import script from "./ProductZoom.vue?vue&type=script&lang=js"
export * from "./ProductZoom.vue?vue&type=script&lang=js"
import style0 from "./ProductZoom.vue?vue&type=style&index=0&id=91344686&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91344686",
  null
  
)

export default component.exports